function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.04,
    height: 1.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 0.93
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.86,
    width: 8.04,
    height: 10.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3399999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 7.220000000000001
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.58,
    width: 8.04,
    height: 13.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 19.125
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.67,
    width: 8.04,
    height: 25.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 38.49
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51.31,
    width: 8.04,
    height: 29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6079999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 65.81
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.31,
    width: 8.04,
    height: 29.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1485714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 95.16
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110.01,
    width: 8.04,
    height: 39.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3399999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 129.9
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 149.8,
    width: 8.04,
    height: 44.03,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3399999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 171.815
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.83,
    width: 8.04,
    height: 46.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8933333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 217.14000000000001
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 240.45,
    width: 8.04,
    height: 49.35,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3399999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 265.125
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 289.79,
    width: 8.04,
    height: 49.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8933333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 314.52500000000003
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 339.26,
    width: 8.04,
    height: 51.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 364.805
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.35,
    width: 8.04,
    height: 53.56,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3399999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 417.13
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 443.91,
    width: 8.04,
    height: 53.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8039999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 470.845
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 497.78,
    width: 8.04,
    height: 62.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6079999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 529.265
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560.75,
    width: 8.04,
    height: 67.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 594.52
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 628.29,
    width: 8.04,
    height: 71.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.02,
    y: 664.145
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 0,
    width: 21.32,
    height: 36.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5533333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.7,
    y: 18.43
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.35,
    y: 0,
    width: 21.6,
    height: 36.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.150000000000006,
    y: 18.43
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.95,
    y: 0,
    width: 22.11,
    height: 36.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.005,
    y: 18.43
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.06,
    y: 0,
    width: 26.11,
    height: 36.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.11500000000001,
    y: 18.43
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.17,
    y: 0,
    width: 26.45,
    height: 36.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.408333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.395,
    y: 18.43
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.62,
    y: 0,
    width: 27,
    height: 36.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.12,
    y: 18.43
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.62,
    y: 0,
    width: 27.52,
    height: 36.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.057777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.38,
    y: 18.43
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.13,
    y: 0,
    width: 34.33,
    height: 36.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8144444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.295,
    y: 18.43
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 0,
    width: 35.48,
    height: 36.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.095999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.20000000000002,
    y: 18.43
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.95,
    y: 0,
    width: 40.48,
    height: 36.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.19,
    y: 18.43
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 0,
    width: 49.48,
    height: 36.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.17,
    y: 18.43
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.91,
    y: 0,
    width: 52.13,
    height: 36.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1433333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.975,
    y: 18.43
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.04,
    y: 0,
    width: 53.24,
    height: 36.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1433333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.66,
    y: 18.43
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.28,
    y: 0,
    width: 53.39,
    height: 36.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1433333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.97499999999997,
    y: 18.43
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.67,
    y: 0,
    width: 58.78,
    height: 36.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.0600000000001,
    y: 18.43
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.45,
    y: 0,
    width: 70.04,
    height: 36.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.457333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.47,
    y: 18.43
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.49,
    y: 0,
    width: 72.51,
    height: 36.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.745,
    y: 18.43
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 36.86,
    width: 68.33,
    height: 41.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.214
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 57.394999999999996
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 77.93,
    width: 68.33,
    height: 46.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 101.12
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 124.31,
    width: 68.33,
    height: 51.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.508333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 149.835
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 175.36,
    width: 68.33,
    height: 57.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.576666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 204.09
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 232.82,
    width: 68.33,
    height: 65.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.23625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 265.765
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 298.7,
    width: 68.33,
    height: 66.17,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.617
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 331.78499999999997
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 364.88,
    width: 68.33,
    height: 73.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.388333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 401.525
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 438.17,
    width: 68.33,
    height: 76.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 476.45500000000004
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 514.75,
    width: 68.33,
    height: 87.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.256153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 558.69
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04,
    y: 602.62,
    width: 68.33,
    height: 97.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.211818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.205,
    y: 651.31
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.37,
    y: 36.86,
    width: 69.67,
    height: 97.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.952857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.20500000000001,
    y: 85.805
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.04,
    y: 36.86,
    width: 77.53,
    height: 97.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.3825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.805,
    y: 85.805
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.57,
    y: 36.86,
    width: 96.68,
    height: 97.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.90999999999997,
    y: 85.805
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.25,
    y: 36.86,
    width: 100.56,
    height: 97.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.876666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.53,
    y: 85.805
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.81,
    y: 36.86,
    width: 126.42,
    height: 97.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.1575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.02,
    y: 85.805
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.23,
    y: 36.86,
    width: 152.77,
    height: 97.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.992142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.615,
    y: 85.805
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.37,
    y: 134.75,
    width: 134.07,
    height: 113.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.612222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.405,
    y: 191.505
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.37,
    y: 248.27,
    width: 134.07,
    height: 118.01,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.801
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.405,
    y: 307.27500000000003
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.37,
    y: 366.27,
    width: 134.07,
    height: 165.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.188181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.405,
    y: 449.265
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.37,
    y: 532.26,
    width: 134.07,
    height: 167.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.313076923076922
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.405,
    y: 616.13
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.44,
    y: 134.75,
    width: 156.52,
    height: 177.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.08666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.7,
    y: 223.725
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.95,
    y: 134.75,
    width: 166.32,
    height: 177.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.11,
    y: 223.725
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.27,
    y: 134.75,
    width: 166.73,
    height: 177.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.818571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.635,
    y: 223.725
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.44,
    y: 312.71,
    width: 489.56,
    height: 387.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.20818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.22,
    y: 506.355
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1964);
export default __webpack_public_path__ + "static/media/1964.a66c36d0763a134e0f75e0a2d0c5683f.svg";
export { ForwardRef as ReactComponent };